// Central registry of feature keys used for role-based gating across the app.
// These keys must match the strings stored in roleState.features (permission names).

export const FEATURE_KEYS = {
  // AMS
  ams_add_record: 'ams_add_record',

  // Settings
  settings_leave_type: 'leave_types',
  settings_leave_policy: 'leave_policies',
  
    
// Department
  department_master: 'department_master',
  
  // Leave (LMS)
  leave_account: 'leave_audit_view',
  leave_applications: 'leave_applications',

  //Conflage
  comp_off_approval: 'comp_off_approval',

  // Users
  users_list: 'users_registration',
  users_roles: 'roles',
  users_designations: 'designations',
  users_employment_types: 'employment_types',
  users_active_list: 'users_active_list',
  users_inactive_list: 'users_inactive_list',

  // Profile
  profile_personal_info: 'user_personal_details_view',
  profile_work_info: 'user_work_details_view',
  profile_management_roles: 'user_management_details_view',
  profile_bank_info: 'bank_details_view',
  profile_bank_details: 'bank_details_edit',

  // Hiring
  hiring_access: 'hiring_access',
  hiring_view_applications: 'hiring_view_applications',
  hiring_create_jd: 'hiring_create_jd',
  hiring_approve_jd: 'hiring_approve_jd',

  // Timesheet
  timesheet_access: 'timesheet_access',
  timesheet_submit: 'timesheet_submit',
  timesheet_approve: 'timesheet_approve',
  timesheet_reports: 'timesheet_reports',
  timesheet_master_data: 'timesheet_master_data',
  timesheet_weekend_work: 'timesheet_weekend_work',
  timesheet_weekend_approve: 'timesheet_weekend_approve',
  timesheet_impediments: 'timesheet_impediments',

  // Incident Management
  incident_module: 'incident_module',
  // Performance Management
  performance_management: 'performance_management',
} as const;

export type FeatureKey = typeof FEATURE_KEYS[keyof typeof FEATURE_KEYS];


